import { sortYearKeys } from "./yearKey";

export function seasonChartHasValues(points) {
  return (points || []).some((point) => point?.value != null);
}

export function buildSeasonChartSeries(seasons = {}, getValue) {
  const map = seasons || {};
  return sortYearKeys(Object.keys(map)).map((year) => {
    const raw = getValue(map[year], year);
    return { year, value: raw == null || Number.isNaN(raw) ? null : raw };
  });
}

export function alignChartSeries(namedSeries = [], { mode = "season" } = {}) {
  if (mode === "careerYear") {
    const maxLen = Math.max(0, ...namedSeries.map((item) => item.points?.length || 0));
    const years = Array.from({ length: maxLen }, (_, index) => String(index + 1));
    return {
      years,
      series: namedSeries.map((item) => ({
        name: item.name,
        data: years.map((_, index) => item.points?.[index]?.value ?? null),
      })),
    };
  }

  const yearSet = new Set();
  namedSeries.forEach((item) => {
    (item.points || []).forEach((point) => yearSet.add(point.year));
  });
  const years = sortYearKeys([...yearSet]);

  return {
    years,
    series: namedSeries.map((item) => {
      const byYear = Object.fromEntries(
        (item.points || []).map((point) => [point.year, point.value])
      );
      return {
        name: item.name,
        data: years.map((year) => (Object.prototype.hasOwnProperty.call(byYear, year) ? byYear[year] : null)),
      };
    }),
  };
}
